"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("../../global/style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. COMPONENT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


var InstagramIcon = function InstagramIcon(_ref) {
  var size = _ref.size,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["size", "color"]); // 2.1. RENDER COMPONENT ..........................................@..........


  return _react["default"].createElement(_style.Svg, _extends({
    iconSize: size,
    viewBox: "0 0 32.25 32.08"
  }, props), _react["default"].createElement(_style.Path, {
    pathColor: color,
    d: "M22.908 14.192v7.077a.649.649 0 0 1-.535.639.94.94 0 0 1-.191.015l-5.79.001h-6.2a.888.888 0 0 1-.263-.032.651.651 0 0 1-.466-.565c-.003-.036-.003-.071-.003-.106v-7.117h1.517c-.343 1.354-.178 2.644.52 3.86a5.207 5.207 0 0 0 2.099 2.014 5.33 5.33 0 0 0 2.849.635c1.687-.096 3.041-.811 4.07-2.11.982-1.336 1.268-2.801.88-4.396h1.513zm-6.724-2.047c1.857 0 3.362 1.46 3.362 3.26 0 1.802-1.504 3.259-3.363 3.258-1.859 0-3.356-1.454-3.36-3.258-.003-1.77 1.477-3.257 3.361-3.26m3.362-2.598c0-.376.295-.66.686-.66h1.994a.663.663 0 0 1 .682.654v1.947a.653.653 0 0 1-.558.648c-.044.008-.087.008-.13.008h-.997c-.331 0-.664-.002-.997.002a.673.673 0 0 1-.675-.567.62.62 0 0 1-.005-.092v-1.94m1.968-2.335h-10.66c-1.669 0-3.035 1.357-3.035 3.016v10.595c0 1.66 1.366 3.017 3.034 3.017h10.661c1.67 0 3.034-1.358 3.034-3.017V10.228c0-1.66-1.364-3.016-3.034-3.016"
  })); // 2.1. END ..................................................................
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. PROP-TYPES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. DEFAULT VALUES .........................................................


InstagramIcon.defaultProps = {
  size: 'default',
  color: ''
}; // 3.1. END ....................................................................
// 3.2. TYPES ..................................................................

InstagramIcon.propTypes = {
  /**  Defines the size of the icon. */
  size: _propTypes["default"].oneOf(['small', 'default', 'large']),

  /**  Defines the color of the icon. */
  color: _propTypes["default"].string
}; // 3.2. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

var _default = InstagramIcon; // END OF FILE #################################################################

exports["default"] = _default;